<template>
  <div :class="prefixCls">
    <quill-editor
      ref="myQuillEditor"
      v-model="content"
      :options="editorOption"
      @blur="onEditorBlur($event)"
      @change="onEditorChange($event)"
      @focus="onEditorFocus($event)"
      @ready="onEditorReady($event)"
    />
  </div>
</template>

<script>
import { Quill, quillEditor } from "vue-quill-editor";
import { ImageExtend, QuillWatch } from "quill-image-extend-module";
import { mapGetters } from "vuex";

Quill.register("modules/ImageExtend", ImageExtend);

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
  // ["blockquote", "code-block"], // 引用  代码块
  // [{ header: 1 }, { header: 2 }], // 1、2 级标题
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
  // [{ script: "sub" }, { script: "super" }], // 上标/下标
  [{ indent: "-1" }, { indent: "+1" }], // 缩进
  // [{'direction': 'rtl'}],                         // 文本方向
  [{ size: ["small", false, "large", "huge"] }], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  [{ font: [] }], // 字体种类
  [{ align: [] }], // 对齐方式
  // ["clean"], // 清除文本格式
  ["link", "image", "video"], // 链接、图片、视频
];
export default {
  name: "VQuillEditor",
  components: {
    quillEditor,
  },
  props: {
    prefixCls: {
      type: String,
      default: "ant-editor-quill",
    },
    // 表单校验用字段
    // eslint-disable-next-line
    value: {
      type: String,
    },
    fileTypeCode: {
      type: String,
      default: "9999",
    },
    placeholder: {
      type: String,
      default: "请填写",
    },
  },
  data() {
    const { placeholder } = this;
    return {
      editorOption: {
        // some quill options
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: function () {
                // 触发图片上传的时候返回的信息
                QuillWatch.emit(this.quill.id); // 使用图片上传插件的统一写法
              },
            },
          },
          ImageExtend: {
            // 使用的图片上传扩展插件
            loading: true,
            name: "img", // 传的参数名
            size: 2, // 单位为M, 1M = 1024KB
            action: this.action, // 后台上传图片的接口地址
            headers: (xhr) => {
              // 请求头
            },
            response: (res) => {
              console.log(res);
              return res.data; // 返回的图片信息
            },
          },
        },
        placeholder,
      },
    };
  },
  computed: {
    ...mapGetters(["access_token"]),
    action() {
      return `${process.env.VUE_APP_ADMIN_BASE_URL}/file/upload/${this.fileTypeCode}`;
    },
    content: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$emit("change", val);
      },
    },
  },
  methods: {
    onEditorBlur(quill) {
      // console.log('editor blur!', quill)
    },
    onEditorFocus(quill) {
      // console.log('editor focus!', quill)
    },
    onEditorReady(quill) {
      // console.log('editor ready!', quill)
    },
    onEditorChange({ quill, html, text }) {
      // console.log('editor change!', quill, html, text)
      this.$emit("change", html);
    },
  },
};
</script>

<style>
.ql-editor {
  height: 150px;
}
</style>
